import { createTheme } from "@mui/material";
import axios from "axios";
import { esES } from "@mui/x-date-pickers/locales";

/**
 * Objeto que contiene las varibales de ambiente definidas en el archivo .env
 */
const config = {
  access_token: process.env.REACT_APP_ACCESS_TOKEN,
  user_id: process.env.REACT_APP_USER_ID,
  user_image: process.env.REACT_APP_USER_IMAGE,
  profile_url: process.env.REACT_APP_PROFILE_URL,
  user_correo: process.env.REACT_APP_USER_CORREO,
  user_nombre: process.env.REACT_APP_USER_NOMBRE,
  user_apellido: process.env.REACT_APP_USER_APELLIDO,
  funciones_Key: process.env.REACT_APP_FUNCIONES_KEY,
  funciones: process.env.REACT_APP_FUNCIONES,
  evidencias_url: process.env.REACT_APP_EVIDENCIAS_URL,
  apiKey: process.env.REACT_APP_API_KEY,
  appVersion: process.env.REACT_APP_VERSION
};

/**
 * Objeto que sirve como instancia de axios para las consultas al backend
 */
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

//Agregamos el api key a todas las peticiones
instance.interceptors.request.use(
  (config) => {
    config.headers["api"] = `${process.env.REACT_APP_API_KEY}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
/**
 * Objeto que contiene constantes a través de toda la aplicación
 */

const constantes = {
  decimales_dinero: 0.01,
  decimales_unidades: 0.01,
};

/**
 * Objeto que contiene todas las funciones existentes en el sistema, los Ids que tiene, son los mismos de base de datos
 */
const functions = {
  ManageRolesAndFunctions: 1,
  ToggleUserState: 2,
  CreateCatalog: 3,
  ModifyCatalog: 4,
  ToggleCatalogState: 5,
  CreateProduct: 6,
  ModifyProduct: 7,
  ToggleProductState: 8,
  CreateCategory: 9,
  ModifyCategory: 10,
  ToggleCategoryState: 11,
  CreateUnit: 12,
  ToggleUnitState: 13,
  ModifyUnit: 14,
  CreateTipoDeEje: 15,
  ModifyTipoDeEje: 16,
  ToggleTipoDeEjeState: 17,
  CreateEje: 18,
  ToggleEjeState: 19,
  ModifyEje: 20,
  CreateUPSE: 21,
  ModifyUPSE: 22,
  ToggleUPSEAddActivities: 23,
  CreateActivity: 24,
  ModifyActivity: 25,
  DeleteActivity: 26,
  CreateSeguimiento: 27,
  ModifySeguimiento: 28,
  DeleteSeguimiento: 29,
  CreateLocalidad: 30,
  ModifyLocalidad: 31,
  CreateUPSE2: 32,
  ViewUPSE2: 33,
  ReviewUPSE2: 34,
  CreateCultivo: 35,
  ModifyCultivo: 36,
  ToggleCultivoState: 37,
  CreateCultivar: 38,
  ModifyCultivar: 39,
  ToggleCultivarState: 40,
  CreateUPSE4: 41,
  ViewUPSE4: 42,
  ReviewUPSE4: 43,
  ManageInstrucciones: 44,
  ManageCategoriaBeneficiario: 45,
  CreateUPSE8: 46,
  ViewUPSE8: 47,
  ReviewUPSE8: 48,
  ManageUPSE8Configuracion: 49,
};

/**
 * Función para encriptar las funciones con las que cuenta el usuario
 * @param {*} value
 * @returns
 */
const encrypt = (value) => {
  return value;
};

/**
 * Función para desencriptar las funciones con las que cuenta el usuario
 * @param {*} value
 * @returns
 */
const decrypt = (value) => {
  // return value
};

/**
 * Función para validar si un usuario cuenta con una función dentro de las funciones asignadas a sus roles.
 * @param {*} user
 * @param {*} func
 * @returns boolean
 */
const validateFunction = (user, func) => {
  return user.funciones.some((item) => {
    return item === func;
  });
};

/**
 * Oculta los 3 puntos de los header de cada columna de las tablas.
 * @param   row  A partir de qué columna ocultar los 3 puntos del header.
 */
function deleteTableDots(row) {
  const headers = document.querySelectorAll(
    ".Mui-TableHeadCell-Content-Actions"
  );
  for (let i = row; i < headers.length; i++) {
    headers[i].hidden = true;
  }
}

/**
 * Función para agregar el caracter de escape a los campos de texto, es importantte para prevenir las inyecciones de SQL.
 * @param {*} str
 */
const addEspaceCharacters = (str) => {
  return str.replace(/[;'"`]/g, "\\$&");
};

/**
 * Objeto que contiene especificaciones para aplicar gobalmente a los estilos de la aplicación
 */
const theme = createTheme({}, esES);

export {
  instance,
  config,
  deleteTableDots,
  functions,
  encrypt,
  decrypt,
  validateFunction,
  addEspaceCharacters,
  theme,
  constantes,
};
